import { mapActions } from 'vuex'
import { eventBus } from '@/main'

export default {
    data() {
        return {
            loadingCAMSConstants: false,
            camsConstants: {},
        }
    },
    methods: {
        ...mapActions({
            FetchCAMSConstants: 'enterpriseDataApi/FetchCAMSConstants',
        }),
        LoadCAMSConstants() {
            if (!!this.camsConstants.HomeUri) eventBus.$emit('cams-constants-fetch:success');
            else {
                this.loadingCAMSConstants = true;
                this.FetchCAMSConstants()
                    .then(response => {
                        this.camsConstants = response;
                        eventBus.$emit('cams-constants-fetch:success');
                    })
                    .catch(error => eventBus.$emit('alert:error', error))
                    .finally(() => this.loadingCAMSConstants = false);
            }
        }
    }
};